export const drawerPaperPropsSx = (theme) => ({
  sx: {
    width: '100%',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.secondary.main,
  },
});

export const toolBarContentsContainerSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  width: '100%',
};

export const backBtnSx = {
  padding: 0,
  marginRight: '16px',
  position: 'absolute',
  left: 0,
};

export const listContainerSx = {
  height: '100%',
  maxWidth: '1100px',
  width: '100%',
  margin: '50px auto 0px auto',
};

export const listItemSx = (theme) => ({
  backgroundColor: theme.palette.background.secondary,
});
